import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function languageReducer(state = initialState.language, action) {
  switch (action.type) {
    case types.CHANGE_LANGUAGE_SUCCESS:
      return action.language;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/language.reducer.js